import React, { useEffect, useState } from 'react';

const LOGO_URL = '/logo.png';

export default function Loader() {
  // Always play the splash on a fresh page load. (Was previously gated by
  // sessionStorage to skip on re-navigations within a tab; user feedback was
  // to bring it back on every page load.)
  const [done, setDone] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setDone(true), 1000);
    return () => clearTimeout(t);
  }, []);
  if (done) return null;
  return (
    <div className="loader-screen fixed inset-0 z-[10000] bg-black flex flex-col items-center justify-center">
      <div className="absolute inset-0 grid-bg opacity-40" />
      <div className="relative z-10 flex flex-col items-center gap-8">
        <div className="relative">
          <div className="absolute inset-0 blur-2xl bg-red-600/40 rounded-full" />
          <div className="relative w-28 h-28 flex items-center justify-center animate-glow rounded-2xl">
            <img src={LOGO_URL} alt="Fitness Pro" className="w-full h-full object-contain drop-shadow-[0_0_20px_rgba(239,43,43,0.5)]" />
          </div>
        </div>
        <div className="text-center">
          <h1 className="font-display text-5xl tracking-[0.3em] text-white">FITNESS<span className="text-red-500">PRO</span></h1>
          <p className="text-xs tracking-[0.5em] text-zinc-500 mt-2">EST. 1992 · GALT, CA</p>
        </div>
        <div className="w-72 h-[2px] bg-zinc-900 overflow-hidden rounded-full">
          <div className="loader-bar h-full bg-red-600" />
        </div>
        <p className="text-[10px] tracking-[0.4em] text-zinc-600">LOADING YOUR JOURNEY</p>
      </div>
    </div>
  );
}
